import { TemplateRef } from '@angular/core';
import { FormControl } from '@angular/forms';
import { FormField } from '@app/shared/models/field.interface';
import { Observable } from 'rxjs';
import { FieldType } from './../constants';
import { FieldOption } from './field.interface';
import { RSQLOperator } from './rsql/rsql.operators';

export enum FilterType {
  INPUT_STANDARD = 'input_standard',
  INPUT_NUMBER = 'input_number',
  CHECKBOX = 'checkbox',
  RADIO = 'radio',
  CHECKBOX_MULTIPLE = 'checkbox_multiple',
  SELECT_STANDARD = 'select_standard',
  SELECT_MULTIPLE = 'select_multiple',
  SELECT_SEARCHABLE = 'select_searchable',
  SELECT_MULTIPLE_SEARCHABLE = 'select_multiple_searchable',
  DATE = 'date',
  HIERARCHY = 'hierarchy'
}

export interface FilterItem {
  title?: string;
  subtitle?: string;
  type: FilterType;
  field: FormField;
  options?: FieldOption[];
  value?: any;
  valueType?: FieldType;
  tooltip?: string;
  observable?: Observable<any>;
  expression?: string;
  defaultValue?: any;
  operator?: RSQLOperator;
}

export interface FilterOutput {
  key: string;
  value: any;
  valueType: FieldType;
  expression?: string;
  operator: RSQLOperator;
  /*
   *  This means we are using the filter in the frontend as a value for other filter field.
   *  This filter WON'T BE SENT TO BACKEND
   */
  disabled?: boolean;
  /*
   * This means, if true, that we are ignoring the filter when showing the user if we have applied filters.
   * This is useful when we want to apply filters by default and hide the component due to right restrictions.
   * When the right allows the component to be shown, the filter will not be hidden.
   */
  hidden?: boolean;
}

export interface FiltersOutput {
  accept: boolean;
  filters?: FilterOutput[];
}

export interface CustomFilter {
  fieldName: string;
  formControl: FormControl;
  buildFun: () => FilterOutput;
  template: TemplateRef<any>;
}
